export const layoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const trackerLinkRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
};
